import { cn } from '@/lib/utils'
import { useWsStore } from '@/stores/wsStore'

export function ConnectionStatus() {
  const connected = useWsStore((s) => s.connected)
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className={cn('h-2 w-2 rounded-full', connected ? 'bg-green-400' : 'bg-red-400 animate-pulse')} />
      <span className="text-gray-400">{connected ? 'Live' : 'Disconnected'}</span>
    </div>
  )
}
